import axios from "axios";
import React, { useEffect, useRef, useState } from "react";

const WEBSITE_URL = process.env.GATSBY_BASE_URL;

export const getToken = async () => {
  try {
    const response = await axios({
      method: "POST",
      url: `${WEBSITE_URL}/wp-json/jwt-auth/v1/token`,
      data: {
        username: process.env.GATSBY_USERNAME,
        password: process.env.GATSBY_PASSWORD,
      },
      headers: {
        Accept: "application/json",
        // "Content-Type": "multipart/form-data",
        // "Access-Control-Allow-Origin": '*',
        // 'Access-Control-Allow-Headers': 'Accept',
        // "Access-Control-Allow-Credentials": 1
      },
    });
    return response.data.token;
  } catch (error) {
    console.error("TokenError", error);
  }
};

export const useSticky = () => {
  const [ratio, setRatio] = useState(0);
  const elementRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const element = entry.target;
        const viewportHeight = typeof window !== 'undefined' && window.innerHeight;

        // Check if the element's top is above the center of the viewport
        console.log("entry", entry, entry.isIntersecting)
        console.log("view", entry.intersectionRatio, entry.boundingClientRect.top, viewportHeight)
        setRatio(entry.intersectionRatio)
        if (entry.isIntersecting) {
          document.body.classList.add('fixed');
        } else {
          document.body.classList.remove('fixed');
        }
      },
      {
        threshold: 1.0 // Trigger at different visibility levels
      }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, []);

  return elementRef;
};